import { render, staticRenderFns } from "./1-akuvox.vue?vue&type=template&id=25e0a9bc&scoped=true&"
import script from "./1-akuvox.vue?vue&type=script&lang=ts&"
export * from "./1-akuvox.vue?vue&type=script&lang=ts&"
import style0 from "./1-akuvox.vue?vue&type=style&index=0&id=25e0a9bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0a9bc",
  null
  
)

export default component.exports